import AuthService from '../services/AuthService';
import { getField, updateField } from 'vuex-map-fields';
import router from '../router';

export const auth = {
	namespaced: true,
	state: {
		checked: false,
		loggedIn: false,
		user: null,
		notifications: [],
	},
	mutations: {
		SIGNUP_SUCCESS(state) {
			state.loggedIn = false;
		},
		SIGNUP_FAILURE(state) {
			state.loggedIn = false;
		},
		SIGNIN_SUCCESS(state, user) {
			state.checked = true;
			state.loggedIn = true;
			state.user = user;
		},
		SIGNIN_FAILURE(state) {
			state.checked = true;
			state.loggedIn = false;
			state.user = null;
		},
		SIGNOUT_SUCCESS(state) {
			state.loggedIn = false;
			state.user = null;
		},
		SET_NOTIFICATIONS(state, notifications) {
			state.notifications = notifications;			
		},
		UNSET_NOTIFICATION(state, index) {
			state.notifications.splice(index, 1);
		},
		ADD_ACTIVE_COURSE(state, courseId) {
			state.user.counts.course.activeIds.push(courseId);
		},
		REMOVE_ACTIVE_COURSE(state, index) {
			state.user.counts.course.activeIds.splice(index, 1);			
		},
		ADD_COMPLETED_COURSE(state, courseId) {
			state.user.counts.course.completedIds.push(courseId);
		},
		REMOVE_COMPLETED_COURSE(state, index) {
			state.user.counts.course.completedIds.splice(index, 1);			
		},
		SET_PROFILE_URL(state, profileUrl) {
			state.user.profileUrl = profileUrl;			
		},
		updateField,
	},
	getters: {
		getField,
		getUserOrg(state, getters, rootstate) {
			// check if user belongs directly to organisation
			const user = state.user;
			const orgId = rootstate.gui.organisation.id;
			let org = user.userOrganisations.find(o => o.organisationId == orgId) || null;
			
			if (org) {
				return org;
				
			} else {
				// check if user belongs to ancestor organisation
				org = user.userOrganisations.find(uo => uo.decendantOrganisations.some(o => o.id == orgId)) || null;
				
				return org;
			}
		},
		getUserRole(state, getters, rootstate) {
			// check if user belongs directly to organisation
			const user = state.user;
			const orgId = rootstate.gui.organisation.id;
			let org = user.userOrganisations.find(o => o.organisationId == orgId) || null;
			
			if (org) {
				return org.role;
				
			} else {
				// check if user belongs to ancestor organisation
				org = user.userOrganisations.find(uo => uo.decendantOrganisations.some(o => o.id == orgId)) || null;
				
				return org.role;
			}
		},
		getUserSeniority(state, getters) {
			const role = getters.getUserRole;
			return role.seniority;
		},
		getUserOrganisationOpts(state) {
			// user thinkhub associations
			let opts = [];
			
			for (let userOrganisation of state.user.userOrganisations) {
				// top level thinkhubs
				opts.push({
					option: userOrganisation.organisation.name,
					value: userOrganisation.organisationId,
				});
				
				// decendant thinkhubs
				const decendants = userOrganisation.decendantOrganisations.map(o => {
					return {
						option: o.name,
						value: o.id,
					};
				});
					
				opts.push(...decendants);
			}
			
			// remove duplicates and sort alphabetically
			return opts.filter((obj, index) => {
				return index === opts.findIndex(o => obj.value === o.value);
			}).sort((a, b) => {
				if (a.value > b.value) {
					return 1;
					
				} else if (a.value < b.value) {
					return -1;
				}
				
				return 0;
			});
		},
	},
	actions: {
		async session({ commit }) {
			try {
				const response = await AuthService.session();
				
				if (response.data.expired) {
					// clear user data to force signin redirect
					commit('SIGNIN_FAILURE');
				}
				
				return response.data.expired;
				
			} catch (error) {
					commit('SIGNIN_FAILURE');
				// pass error to caller
				throw error;
			}
		},
		async status({ commit }) {
			try {
				const response = await AuthService.status();
				if (response.data.loggedIn) {
					commit('SIGNIN_SUCCESS', response.data.user);
				} else {
					commit('SIGNIN_FAILURE');
				}
				
			} catch (error) {
				commit('SIGNIN_FAILURE');
				// pass error to caller
				throw error;
			}
		},
		async signin({ commit }, formData) {
			try {
				const response = await AuthService.signin(formData);
				
				if (response.data.user) {
					commit('SIGNIN_SUCCESS', response.data.user);
				}
				
				return response;
				
			} catch (error) {
				commit('SIGNIN_FAILURE');
				throw error;
			}
		},
		async signout({ commit }) {
			try {
				await AuthService.signout();
				commit('SIGNOUT_SUCCESS');
				
			} catch (error) {
				console.log(error.response.data);
				throw error;
			}
		},
		setProfileUrl({ commit }, profileUrl) {
			commit('SET_PROFILE_URL', profileUrl);
		},
		setCourseCompleted({ commit, state }, {courseId, userId}) {
			// course completed by user
			const activeIds = state.user.counts.course.activeIds;
			let committed = false;
			
			if (activeIds.includes(courseId) && userId === state.user.id) {
				const index = activeIds.indexOf(courseId);
				
				if (index > -1) {
					commit('REMOVE_ACTIVE_COURSE', index);
					commit('ADD_COMPLETED_COURSE', courseId);
					committed = true;
				}
			}
			
			if (committed && router.currentRoute.value.name === 'Learn') {
				// refresh course list only if user is on it
				this.dispatch('courses/dbUserCourses');			
			}
		},
		setCourseCounts({ commit, state }, {courseId, assignedUserIds, unassignedUserIds}) {
			// course access updated in backend
			const activeIds = state.user.counts.course.activeIds;
			const completedIds = state.user.counts.course.completedIds;
			let committed = false;
			
			if (!activeIds.includes(courseId) && assignedUserIds.includes(state.user.id)) {
				// auth user assigned to new course
				commit('ADD_ACTIVE_COURSE', courseId);
				committed = true;
				
			} else if (activeIds.includes(courseId) && unassignedUserIds.includes(state.user.id)) {
				// auth user unassigned from course
				const index = activeIds.indexOf(courseId);
				
				if (index > -1) {
					commit('REMOVE_ACTIVE_COURSE', index);
					committed = true;
				}
			
			} else if (completedIds.includes(courseId) && unassignedUserIds.includes(state.user.id)) {
				// auth user unassigned from course
				const index = completedIds.indexOf(courseId);
				
				if (index > -1) {
					commit('REMOVE_COMPLETED_COURSE', index);
					committed = true;
				}
			}
			
			if (committed && router.currentRoute.value.name === 'Learn') {
				// refresh course list only if user is on it
				this.dispatch('courses/dbUserCourses');			
			}
		},
		/*
		setActiveCount({ commit }, data) {
			commit('SET_ACTIVE_COUNT', data);
		},
		setCompletedCount({ commit }, data) {
			commit('SET_COMPLETED_COUNT', data);
		},*/
		async signup({ commit }, user) {
			try {
				await AuthService.signup(user);
				commit('SIGNUP_SUCCESS');
				
			} catch (error) {
				commit('SIGNUP_FAILURE');
				throw error;
			}
		},
		async dbNotifications({ commit }) {
			try {
				// fetch user organisation notifications from db
				const {data} = await AuthService.notifications();
				commit('SET_NOTIFICATIONS', data.notifications);
				
			} catch (error) {
				console.log(error);
				throw error;
			}
		},
		async dismissNotification({ commit, state }, id) {
			try {
				// dismiss notification 
				const index = state.notifications.findIndex(n => n.id === id);
				
				if (index > -1) {
					await AuthService.dismiss(id);
					commit('UNSET_NOTIFICATION', index);
				}
				
			} catch (error) {
				console.log(error);
				throw error;
			}
		},
	}
};
